var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRedirect = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.5385V15.2115C15.75 15.4869 15.6405 15.7511 15.4458 15.9458C15.2511 16.1405 14.9869 16.25 14.7115 16.25H3.28846C3.01304 16.25 2.74891 16.1405 2.55416 15.9458C2.35941 15.7511 2.25 15.4869 2.25 15.2115V3.78846C2.25 3.51304 2.35941 3.24891 2.55416 3.05416C2.74891 2.85941 3.01304 2.75 3.28846 2.75H7.96154",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1154 2.75H15.75V6.38462",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.75L9 9.5",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedirect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redirect.6304cdc0.svg";
export { ForwardRef as ReactComponent };